"use client";

import { useEffect } from "react";
import { CustomScriptPlacement } from "@/cms/models";
import { injectCustomScript } from "@/utils/inject-custom-script";

interface CustomScriptsProps {
  code: string;
  placement: CustomScriptPlacement;
}

/**
 * Injects one third-party snippet from the Scripts tab in b2b.
 *
 * Decoding and insertion both happen in the browser, and the whole mechanism lives in
 * injectCustomScript so it can be tested without React — see inject-custom-script.ts for why
 * a parsed <script> has to be re-created before it will run.
 */
export default function CustomScripts({ code, placement }: CustomScriptsProps) {
  useEffect(() => injectCustomScript(code, placement), [code, placement]);

  return null;
}
